import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";
import type { PresignedUrl } from "@src/domain/pascos/value_objects/presigned_url";

/**
 * Get Pasco Download URL Use Case
 * Retrieves a presigned URL for downloading/viewing a PASCO file
 */
export class GetPascoDownloadUrlUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    async execute(pascoId: string): Promise<PresignedUrl> {
        if (!pascoId) {
            throw new Error("Pasco ID is required");
        }

        return await this.pascoRepository.getDownloadUrl(pascoId);
    }
}
